export default __webpack_public_path__ + "static/jira-service-management_attribution_light-554bebe9ec0811d372548d83bbcea741.svg";